<template>
<v-container fluid>        
    <div id="app ">
      <v-row>
        <v-col cols="11">
          <Breadcrumb
            class="row justify-content-center mt-4"
          />
        </v-col>
        <v-col cols="1" v-if="showLoader">
          <LoaderProgress></LoaderProgress>
        </v-col>
      </v-row>
    </div>
    <v-row>
      <v-col>
        <!-- <filterHeaderComp /> -->
        <newFiltercomp :filter_data="param" />
      </v-col>
    </v-row>
    <v-data-table
      ref="theDataTable"
      :headers="headersData"
      :items="operatorsData"
      :search="search"
      :custom-sort="DateSort"
      :items-per-page="5"
      class="elevation-1"
      @pagination="pagination = $event"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-row>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
          <v-spacer></v-spacer>
          
          <v-menu
            v-model="menu"
            :close-on-content-click="false"
            :nudge-width="50"
            offset-x
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class=""
                outlined
                fab
                small
                color="#0C479D"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>icon-download</v-icon>
              </v-btn>
            </template>
            <v-card>
              <v-divider></v-divider>

              <v-list>
                <v-list-item>
                  <v-list-item-action>
                    <vue-json-to-csv
                      :json-data="dataDownload"
                      :csv-title="'Machine Transaction Report Data'"
                    >
                      <v-btn color="indigo" dark style="">
                        CSV
                      </v-btn>
                    </vue-json-to-csv>

                    <!-- <v-btn
          color="indigo"
          dark
          v-bind="attrs"
          v-on="on"
        >
          Menu as Popover
        </v-btn> -->
                  </v-list-item-action>
                  <!-- <v-list-item-title>CSV Download</v-list-item-title> -->
                </v-list-item>

                <v-list-item>
                  <v-list-item-action>
                    <v-btn @click="createPDF" color="indigo" dark>PDF </v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
            </v-card>
          </v-menu>
        </v-toolbar>
      </template>
      </v-data-table>
</v-container>
</template>

<script>
import Breadcrumb from "../components/breadcrumbs.vue";
import LoaderProgress from "../components/progressLoader";
import newFiltercomp from "../components/newFiltercomp.vue";
import axios from "axios";
import VueJsonToCsv from "vue-json-to-csv";
// import constants from "../constants";
import router from "../router";
import jsPDF from "jspdf";
import "jspdf-autotable";
// const logo = require("../assets/trinitiimage.png");
export default {
  components: {
    VueJsonToCsv,
    newFiltercomp,
    //  filterHeaderComp
    Breadcrumb,
    LoaderProgress,
  },
data() {
    return {
      items: [
        {
          text: "Home",
          disabled: false,
          href: "/",
        },
        {
          text: "Report Menu",
          disabled: true,
          href: "/",
        },
        {
          text: "Machine Transaction Report",
          disabled: true,
        },
      ],
      showWarning: false,
      showLoader: false,
          param : {
        machine : true,
        time_period: false,
        check : false,
        aggfunc : false,
        date : false,
        date_2 : false,
        time: false,
        time2: false,
        select_1: 24
  },	
      dataDownload: [],
      search: "",
      operatorsData: [],
      menu: false,
      headersData: [],
      pagination: {
        page: null,
        itemsPerPage: null,
        pageStart: null,
        pageStop: null,
        pageCount: null,
        itemsLength: null,
      },
    };
  },
  mounted() {},
methods: {
    DateSort: function(items, index, isDesc) {
      if (index[0] == "Timestamp") {
              console.log("chekcing index inside if",items);

        items.sort((a, b) => {
          if (!isDesc[0]) {
            return new Date(b[index]) - new Date(a[index]);
          } else {
            return new Date(a[index]) - new Date(b[index]);
          }
        });
      } else if (
        index[0] != "Timestamp" 
      ) {
                      console.log("chekcing index inside elif",items);

        items.sort((a, b) => {
          if (!isDesc[0]) {
            if (typeof a[index] == "number" ) {
                return b[index] - a[index];
            }
            else
            {
            console.log("checking incase a isDesc");

            }
          } else {
             if (typeof a[index] == "number" ) {
                return a[index] - b[index];
            }
            else{
            console.log("checking incase else", a[index], b[index]);

            }
          }
        });
      }

      return items;
    },
    createPDF() {
      let content = this.$refs["theDataTable"];
      console.log("pagination", this.pagination);
      let doc = new jsPDF("latitude");
      doc.text(14, 7.5, "Machine Transaction Report");
       doc.addImage(
        this.getImgUrl1(this.$config.image_inside_pdf),
        "png",
        this.$config.first_dimension_separate_again,
        this.$config.second_dimension_separate,
        this.$config.third_dimension_separate,
        this.$config.fourth_dimension_separate_again
      );
      let columnHeaders = [
        "Production Start Time",
        "Production End Time",
        "Product Name",
        "Production Quantity",
        "Wastage",
        // "Machine State"    
      ];
      let rows = [];
      content.items.forEach((data, index) => {
        if (
          index >= this.pagination.pageStart &&
          index < this.pagination.pageStop
        ) {
          let tempRow = [    
            data.production_start_time || "",
            data.production_end_time || "",
            data.product_name || "",
            data.Production_Quantity || 0,
            data.Wastage || 0,
            // data.Machine_State || 0,
            
          ];
          rows.push(tempRow);
        }
      });
      console.log("checkign temp row=>", rows);
      doc.setFontSize(9);
      doc.autoTable(columnHeaders, rows, { startY: 11.5 });
      let d = new Date();
      doc.save(
        `Machine_Transaction_Report ${d.toISOString().slice(0, 10) +
          " " +
          d
            .toTimeString()
            .split("(")[0]
            .slice(0, -1)}.pdf`
      );
    },
     intervalFetchData: function(
      machine_id,
      startDate,
      endDate,
      show,
      grp_show,
      check
    ) {
      this.machine_id_Selected = machine_id;
      this.start_date = startDate;
      this.end_date = endDate;
      console.log("machine id", machine_id);
      console.log(
        "selected start date",
        startDate,
        "selected end date",
        startDate
      );

      this.searchNew(
        this.machine_id_Selected,
        startDate,
        endDate,
        show,
        grp_show,
        check
      );
    },
      sortKeys(obj_1,key) {
          let ditItem = {}
            console.log("checking keys and dicts outside",obj_1,key)
              for (let i in key )
              {
ditItem[key[i]] = obj_1[key[i]];

              }
console.log("Checking ditItem",ditItem);
            return ditItem;
        },
    searchNew: function(machine_id, startDate, endDate, show, grp_show, check) {
      this.start_date = startDate;
      this.end_date = endDate;
      this.machine_id_Selected = machine_id;
      console.log(
        "machine select",
        this.machine_id_Selected,
        "Done to say",
        machine_id,
        check
      );
      let params = "";
      if (this.start_date == "") {
        params = `?machine_id=${machine_id}`;
      } else {
        params = `?machine_id=${machine_id}&startdate=${this.start_date}&enddate=${this.end_date}&agg_function=${show}&timeframe=${grp_show}`;
      }
      let config = {
        method: "get",
        url: `${this.$config.backend_url}/getMachineTransactionReportData${params}`,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      };
      this.setGridData(config);
    },
    setGridData: function(config) {
      this.headersData = [
                {
          text: "Production Start Time",
          value: "production_start_time",
          sortable: true,
        },
        {
          text: "Production End Time",
          value: "production_end_time",
          sortable: true,        },
        {
          text: "Product Name",
          value: "product_name",
          sortable: true,
        },
        {
          text: "Production Quantity",
          value: "Production_Quantity",
          sortable: true,
        },
            {
          text: "Wastage",
          value: "Wastage",
          sortable: true,
        },
        
        //     {
        //   text: "Total Production",
        //   value: "Total_Production",
        //   sortable: true,
        // },
        //     {
        //   text: "Machine State",
        //   value: "Machine_State",
        //   sortable: true,
        // },


      ];

      this.showLoader = true;
      this.showWarning = false;
      this.noteLastAPICallTime();
      axios(config)
        .then((response) => {
          let _data = response.data.data;
          console.log("checking report");
          console.log("checkign resp", response.data.data);
          console.log("checkign resp keys",response.data.keys);
          let keys = response.data.keys || [];  
          this.operatorsData = response.data.data;
          console.log("thisisdata", this.operatorsData);
          let result = [];
          for (let i in this.operatorsData) 
          {
            
            console.log("checking keys before sending",keys,this.operatorsData[i]);
           let val = this.sortKeys(this.operatorsData[i],keys);
            console.log("checking val at also",val);
          result.push( val);

          }
          this.dataDownload = result;
          console.log("checking csv data",result,this.dataDownload);
          this.item = _data;
          this.showLoader = false;
        })
        .catch((error) => {
          this.showLoader = false;
          if (error.response && error.response.status === 401) {
            sessionStorage.clear();
            router.push("/login");
          } else {
            this.showWarning = true;
            this.item = [];
            console.log("axios error", error.message);
          }
        });
    },
  },
}
</script>

<style scoped>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>

